import { defineChain } from "viem";

export const API_URL = (import.meta.env.VITE_API_URL as string | undefined)?.replace(/\/$/, "") ?? "https://strike.fastapi.space";

export const robinhood = defineChain({
  id: 4663,
  name: "Robinhood Chain",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: { default: { http: ["https://rpc.mainnet.chain.robinhood.com"] } },
  blockExplorers: { default: { name: "Blockscout", url: "https://robinhoodchain.blockscout.com" } },
  contracts: { multicall3: { address: "0xcA11bde05977b3631167028862bE2a173976CA11" } },
});

export const EXPLORER = "https://robinhoodchain.blockscout.com";
export const PONS_URL = "https://www.ponsfamily.com/launchpad";
export const SUPPLY = 1_000_000_000;
/** "auto" previews until the API reports a token; scripts/go-live.sh sets "off" so the site never shows demo data. */
export const PREVIEW_MODE: "auto" | "off" = "off";
/** The $STRIKE contract address shown on the site. All zeroes until launch: set the real one after deploying. */
/** Split of every fee the treasury distributes (StrikeTreasury.vaultShareBps = 30%). */
export const HOLDER_SHARE = 70;
export const VAULT_SHARE = 30;
export const STRIKE_CA = "0x9ef8C50E20FAF002c90824B25E760D1B70c62B4D";
export const X_URL = "https://x.com/"; // set when the account exists

export const txUrl = (hash: string) => `${EXPLORER}/tx/${hash}`;
export const addrUrl = (a: string) => `${EXPLORER}/address/${a}`;
